import { html } from 'lit-html';
import { KeywordDetailJsEnv } from '../../models/keyword_detail_js_env';
import { getAssetsUrlBase } from '../../../../core/models/common/static_resource_util';

export const SearchErrorArea = (model: KeywordDetailJsEnv) => {
  return html`
    <div class="m-information -warning">
      <p class="m-information_hdg">
        <span class="m-information_hdgicon">
          <span class="a-icon -size24">
            <img
              class="a-icon_img"
              src="${getAssetsUrlBase()}images/icon_information_red.svg"
              alt=""
              width="24" height="24"
            />
          </span>
        </span>
        <span class="m-information_hdgmain">
          <span class="m-information_hdgmain_text">${model.errorMessage.title}</span>
        </span>
      </p>
      <div class="m-information_textcontent">
        <p class="a-text">${model.errorMessage.content}</p>
      </div>
    </div>
  `;
};
